module.exports = __webpack_public_path__ + "static/media/bbc_news_live_world-africa-36328976_plot.e2da1a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/storySparklines/bbc_news_live_world-africa-36328976_plot.png
// module id = 354
// module chunks = 0